import { useState, useRef, useCallback, useEffect } from 'react';

export const useTracking = (store, cookieAccepted) => {
  const [trackingAdded, setTrackingAdded] = useState({
    google_tag_manager: false,
    google_global_site: false,
    google_analytics: false,
    facebook_pixel: false
  });

  const deferredSteps = useRef([]);
  const isTrackingInitialized = useRef(false);

  const addTracking = useCallback((step) => {
    if (typeof store.trackings === "undefined") return;

    if (typeof store.trackings.google_tag_manager !== "undefined" && 
        !trackingAdded.google_tag_manager &&
        (typeof store.trackings.google_global_site === "undefined" || !trackingAdded.google_global_site) &&
        store.trackings.google_tag_manager.steps.includes(step)) {
      
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
          'gtm.start': new Date().getTime(), 
          event: 'gtm.js'
        });
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s), 
            dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', store.trackings.google_tag_manager.data);
      
      setTrackingAdded(prev => ({ ...prev, google_tag_manager: true }));
    } 
    else if (typeof store.trackings.google_global_site !== "undefined" && 
             !trackingAdded.google_global_site &&
             (typeof store.trackings.google_tag_manager === "undefined" || !trackingAdded.google_tag_manager) &&
             store.trackings.google_global_site.steps.includes(step)) {
      
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      gtag('js', new Date());
      
      gtag('config', store.ggs || store.trackings.google_global_site.data);

      const f = document.getElementsByTagName("script")[0];
      const j = document.createElement("script");
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtag/js?id=' + store.trackings.google_global_site.data;
      f.parentNode.insertBefore(j, f);
      
      setTrackingAdded(prev => ({ ...prev, google_global_site: true }));
    }

    if (typeof store.trackings.google_analytics !== "undefined" && 
        !trackingAdded.google_analytics &&
        store.trackings.google_analytics.steps.includes(step)) {
      
      (function (i, s, o, g, r, a, m) {
        i['GoogleAnalyticsObject'] = r;
        i[r] = i[r] || function () {
            (i[r].q = i[r].q || []).push(arguments)
        };
        i[r].l = 1 * new Date();
        a = s.createElement(o);
        m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m);
      })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
      
      const tracker = store.trackings.google_analytics.data;
      window.ga('create', tracker, 'auto');
      window.ga('send', 'pageview');
      
      setTrackingAdded(prev => ({ ...prev, google_analytics: true }));
    }

    if (typeof store.trackings.facebook_pixel !== "undefined" && 
        !trackingAdded.facebook_pixel &&
        store.trackings.facebook_pixel.steps.includes(step)) {
      
      // eslint-disable-next-line no-unused-expressions
      !function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
            n.callMethod ?
            n.callMethod.apply(n, arguments) : n.queue.push(arguments)
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      
      const fbPixel = store.trackings.facebook_pixel.data;
      window.fbq('init', fbPixel);
      window.fbq('track', 'PageView');
      
      setTrackingAdded(prev => ({ ...prev, facebook_pixel: true }));
    }
  }, [store.trackings, trackingAdded, store.ggs]);

  const prepareTracking = useCallback((step) => {
    if (store.showCookieAcceptance) {
      if (cookieAccepted) {
        addTracking(step);
      } else {
        if (!isTrackingInitialized.current) {
          deferredSteps.current.push(step);
          const listener = () => {
            if (cookieAccepted) {
              deferredSteps.current.forEach(s => addTracking(s));
              deferredSteps.current = [];
              isTrackingInitialized.current = true;
              window.removeEventListener('cookieAccepted', listener);
            }
          };
          window.addEventListener('cookieAccepted', listener);
        }
      }
    } else {
      addTracking(step);
    }
  }, [cookieAccepted, store.showCookieAcceptance, addTracking]);

  useEffect(() => {
    if (!cookieAccepted) {
      setTrackingAdded({
        google_tag_manager: false,
        google_global_site: false,
        google_analytics: false,
        facebook_pixel: false
      });
      deferredSteps.current = [];
      isTrackingInitialized.current = false;
    }
  }, [cookieAccepted]);

  return {
    prepareTracking,
    addTracking,
    trackingAdded
  };
};
